(function() {
  var currentProductId = '';
  var currentReviewsImageIndex = -1;
  var productReviewsObj = {};
  var isKindBelong = LS.ui.isKindBelong(1);
  var homeScrollReviewsLen = 0; // 首页评论滚动距离
  var reviewsDetailImgScrollLen = 0; // 评论详情图片滚动距离
  var homeRecomLen = 0; // 首页评论数量
  var reviewsListHtml = `
    <% for ( var [index, item] of data.entries() ) { %>
      <div class="reviews-item reviews-item-<%= item.id %>" data-id="<%= item.id %>" data-score="<%= item.rating %>" data-index="<%= index %>">
        <div class="reviews-item_left-wrapper">
          <div class="reviews-item_left-name"><%= item.username %></div>
          <div class="reviews-item_variant">
            <span class="reviews-item_variant-item"><%t('public.reviews.label_color', '', 1) %>: <i><%= item.color %></i></span>
            <span class="reviews-item_variant-item"><%t('public.reviews.label_size', '', 1) %>: <i><%= item.size %></i></span>
          </div>
          <div class="reviews-item_info">
            <% if ( item.fit ) { %>
              <div class="reviews-item_info-item"><%t('public.reviews.label_fit', '', 1) %>: <i><%= item.fit %></i></div>
            <% } %>
            <div class="reviews-item_info-item"><%t('public.reviews.label_quality', '', 1) %>: <i><%= item.quality %></i></div>
            <% if ( item.price ) { %>
              <span class="reviews-item_info-item reviews-item_info-item-price"><%t('public.reviews.label_value', '', 1) %>: <i><%= item.price %></i></span>
            <% } %>
          </div>
        </div>

        <div class="reviews-item_mid-wrapper">
          <div class="reviews-star-box"></div>
          <div class="reviews-item_text"><%= item.comments %></div>
        </div>

        <% if ( item.commentImages && item.commentImages.length > 0 ) { %>
          <div class="review-item_right-wrapper">
            <% for ( var imageItem of item.commentImages ) { %>
            <div class="review-item_image-item js-lazyload-img">
              <img class="review-item_image" data-lazyload-src="<%= imageItem %>">
            </div>
            <% } %>
          </div>
        <% } %>

        <div class="reviews-item_date"><%= item.createTimeStr %></div>      
      </div>  
    <% } %>
  `;
  var reviewsDrawer = `
    <div class="ls-main-popupbox reviews-popupbox">
      <div class="ls-main-popupbox-overlay"></div>
        <div class="ls-main-popupbox-con">
          <div class="main-popupbox-con-title">${LS.$t('public.reviews.title_reviews')}
            <div class="title-close">
              <img src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/ls-pop-close-icon.png?v=1657006987" />
            </div>
          </div>
          <div class="reviews-list reviews-list_dialog"></div>
        </div>  
      </div>
    </div>    
  `;
  var reviewsDetailDrawer = `
    <div class="ls-main-popupbox reviews-detail-container">
      <div class="ls-main-popupbox-overlay"></div>
      <div class="ls-main-popupbox-con reviews-detail-box">
        <div class="reviews-close-icon title-close">         
          <img src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/looksky_popup_close2.png?v=1661839898" />       
        </div>
        <div class="reviews-detail_slider-box">
        
        </div>
        <div class="reviews-detail_info-wrapper"></div>
      </div>
    </div>
  `;
  var reviewDetailSliderHtml = `
    <div class="reviews-detail_slider-index-wrapper"><span class="reviews-detail_slider-index"></span>/<%= data.length %></div>
    <div class="reviews-detail_slider-wrapper">
      <div class="reviews-detail_slider-images-wrapper">
        <% for ( var item of data ) { %>
          <div class="review-detail_slider-image-item js-lazyload-img" data-reviews-id="<%= item.reviewsId %>">
            <img class="review-detail_slider-image" data-lazyload-src="<%= item.url %>">
          </div>
        <% } %>
      </div>

      <div class="reviews-detail_slider-arrow-wrapper">
        <img class="reviews-detail_slider-arrow" data-type="1" src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/product_slider_arrow_left_100x.png?v=1651126357">
        <img class="reviews-detail_slider-arrow" data-type="2" src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/product_slider_arrow_right_100x.png?v=1651126357">
      </div>
    </div>
  `;
  var reviewsDetailInfoHtml = `
    <div class="reviews-detail_header-wrapper">
      <div class="reviews-detail_header-name"><%= data.username %></div>
      <div class="reviews-detail_header-date"><%= data.createTimeStr %></div>
    </div>

    <div class="reviews-detail_variant-wrapper">
      <div class="reviews-detail_variant">
        <span class="reviews-detail_variant-item">Color: <i><%= data.color %></i></span>
        <span class="reviews-detail_variant-item">Size: <i><%= data.size %></i></span>
      </div>
     
    </div>
    <div class="reviews-detail_info">
      <div class="reviews-detail_info-item">Fit Type: <i><%= data.fit %></i></div>
      <div class="reviews-detail_info-item">Fabric: <i><%= data.quality %></i></div>
      <div class="reviews-star-box"></div>
    </div>
    <div class="reviews-detail_text"><%= data.comments %></div>
  `;
  // <div class="index_review-item_image-wrapper js-lazyload-img">
  //   <img class="index_review-item_image" data-lazyload-src="<%= item.commentImages[0] %>">
  // </div>
  var reviewsBlockItemHtml = `
    <div class="reviews-inner">
      <% for ( var [index, item] of data.entries() ) { %>
        <div class="reviews-item index_reviews-item index_reviews-item-<%= index %>" data-product-id="<%= item.productId %>" data-reviews-id="<%= item.id %>" data-score="<%= item.rating %>" data-index="<%= index %>">
          <div class="reviews-item_header-wrapper">
            <div class="reviews-item_header-name"><%= item.username %></div>
            <div class="reviews-item_header-date"><%= item.createTimeStr %></div>
          </div>  
          <div class="reviews-item_variant-wrapper">
            <div class="reviews-item_variant">
              <span class="reviews-item_variant-item"><%t('public.reviews.label_color', '', 1) %>: <i><%= item.color %></i></span>
              <span class="reviews-item_variant-item"><%t('public.reviews.label_size', '', 1) %>: <i><%= item.size %></i></span>
            </div>
            <div class="reviews-star-box"></div>
          </div>
          <div class="reviews-item_info">
            <span class="reviews-item_info-item"><%t('public.reviews.label_quality', '', 1) %>: <i><%= item.quality %></i></span>
            <span class="reviews-item_info-item"><%t('public.reviews.label_fit', '', 1) %>: <i><%= item.fit %></i></span>
            <% if ( item.price ) { %>
              <span class="reviews-item_info-item reviews-item_info-item-price"><%t('public.reviews.label_value', '', 1) %>: <i><%= item.price %></i></span>
            <% } %>
          </div>
          <div class="reviews-item_text index_reviews-item_text"><%= item.comments %></div>
        </div>
      <% } %>
    </div>
  `;

  var reviewsModule = `
  <div class="product-reviews_module-item-title"><%= data.label %></div>
    <div class="product-reviews_module-list">
      <% for ( var [index, item] of data.list.entries() ) { %>
        <div class="product-reviews_module-list-item">
          <div class="product-reviews_module-item-label"><%= item.label %></div>
          <div class="product-reviews_module-item-progress-wrapper" data-value="<%= item.value %>" data-total-count="<%= data.totalCount %>">
            <div class="product-reviews_module-item-progress" style="width: <%= item.width %>px;"></div>
          </div>
          <div class="product-reviews_module-item-percent"><%= item.percent %>%</div>
        </div>
      <% } %>
    </div>
  </div>
`;

  var reviewsFn = {
    bindEvent: function() {
      $(document).on('click', '.reviews-detail_slider-arrow-wrapper .reviews-detail_slider-arrow', function() {
        reviewsFn.handleDetailsArrow(this);
      });

      $(document).on('click', '.switch-icon-left', function() {
        handleScroll(0);
      });

      $(document).on('click', '.switch-icon-right', function() {
        handleScroll(1);
      });

      $('#product-reviews-viewmore_pc').on('click', function() {
        var productId = $("#product-page").attr('data-product-id') || '';
        reviewsFn.getSingleProductAllReviews(productId);
        LS.ui.popupNoScrollHandle();
        LS.ui.productFn.reportProductInfo(LS.ui.productReportMap['clickReviewsViewMore'], LS.ui.reportType['click'], 1);
      });

      $(document).on('click', '#reviews-close-icon', function() {
        $('.reviews-container').hide();
        LS.ui.popupRecoveryScrollHandle();
      });

      $(document).on('click', '#reviews-detail-close-icon', function() {
        $('.reviews-detail-container').hide();
        LS.ui.popupRecoveryScrollHandle();
      });

      $(document).on('click', '.reviews-tab-wrapper .reviews-tab-item', function() {
        $(this).addClass('active').siblings().removeClass('active');
      })

      $(document).on('click', '.looksky-reviews_list-wrapper .index_reviews-item', function() {
        var productId = $(this).attr('data-product-id') || '';
        var reviewsId = $(this).attr('data-reviews-id') || '';
        reviewsFn.getReviewsDetail(productId, reviewsId);
      })

      $(document).on('click', '.product-reviews-item', function() {
        var idx = $(this).attr('data-index') || '';
        currentReviewsImageIndex = idx;
        reviewsFn.handleSingleDetail(productReviewsObj);
      })

      $(document).on('click', '.drawer-reviews-item', function() {
        var idx = $(this).attr('data-index') || '';
        currentReviewsImageIndex = idx;
        reviewsFn.handleSingleDetail(productReviewsObj);
      })

      function handleScroll(type) {
        var scrollLen = 3 * (400 + 16); // 一次滚动3个
        var max = homeRecomLen * (400 + 16) - $('.looksky-reviews_list-wrapper').width();
        if (max < 0) return;
        if (type === 0) {
          homeScrollReviewsLen = homeScrollReviewsLen - scrollLen;
          if (homeScrollReviewsLen < 0) {
            homeScrollReviewsLen = 0;
          } 
        } else if (type === 1) {
          homeScrollReviewsLen = homeScrollReviewsLen + scrollLen;
          if (homeScrollReviewsLen >= max) {
            homeScrollReviewsLen = max;
          } 
        }
        $('.reviews-inner').css('margin-left', `-${homeScrollReviewsLen}px`);
      }
    },
    handleDetailsArrow: function(self) {
      var arrowType = $(self).attr('data-type');
      var scrollLen = $('.reviews-detail_slider-box')[0].getBoundingClientRect().width || 0;
      var domLen = $('.review-detail_slider-image-item').length;
      var max = scrollLen * (domLen - 1);
      var curIdx = 1;
      if (arrowType === '1') {
        curIdx = Number($('.reviews-detail_slider-index').text()) - 1;
        if (curIdx <= 0) return;
        if (reviewsDetailImgScrollLen <= 0) {
          reviewsDetailImgScrollLen = 0;
        }
        reviewsDetailImgScrollLen = reviewsDetailImgScrollLen - scrollLen;
        
      } else {
        curIdx = Number($('.reviews-detail_slider-index').text()) + 1;
        if (curIdx > domLen) return;
        reviewsDetailImgScrollLen = reviewsDetailImgScrollLen + scrollLen;
        if (reviewsDetailImgScrollLen >= max) {
          reviewsDetailImgScrollLen = max;
        }
      }
      $('.reviews-detail_slider-index').text(curIdx);
      if (reviewsDetailImgScrollLen < 1) reviewsDetailImgScrollLen = 0; // fix 计算精度问题
      $('.reviews-detail_slider-images-wrapper').css('margin-left', `-${reviewsDetailImgScrollLen}px`);
      var targetImg = $('.review-detail_slider-image-item')[curIdx - 1] || {};
      if (targetImg) {
        var reviewsId = $(targetImg).attr('data-reviews-id');
        var targetItem = reviewsFn.handleComments(productReviewsObj.userComments).find(item => reviewsId === item.id + '');
        var reviewInfoTml = LS.tmpl(reviewsDetailInfoHtml, targetItem);
        $('.reviews-detail-container').find('.reviews-detail_info-wrapper').html(reviewInfoTml);
      }
    },
    insertDrawer: function() {
      $('body').append(reviewsDrawer);
    },
    insertDetailDrawer: function() {
      $('body').append(reviewsDetailDrawer);
    },
    getReviewsDetail: function(productId, reviewsId) {
      if (!productId) return;
      if (currentProductId === productId) {
        $('.reviews-detail-container').show();
        return;
      };
      LS.ajax({
        url: LS.ui.routes.getProductCommentInfo,
        type: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          productId: productId + ''
        }),
        success: function (res) {
          if (res.hasError || res.code !== '0') {
            // LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
            return;
          };
          var commentList = res.data.userComments;
          if (commentList.length) {
            if (!isKindBelong.clothes) {
              for (var i = 0, len = commentList.length; i < len; i++) {
                delete commentList[i].fit;
              }
            }
            productReviewsObj = res.data;
            currentReviewsImageIndex = commentList.findIndex(item => item.id == reviewsId);
            reviewsFn.handleSingleDetail(productReviewsObj);
          }
        },
        error: function (error) {
          // LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
        },
      });
    },
    handleSingleDetail(data) {
      var { avgRating, commentCount, userComments } = data || {};
      var containerDom = $('.reviews-detail-container');
      // 该评论没图片禁止点击
      if (!userComments[currentReviewsImageIndex].commentImages || !userComments[currentReviewsImageIndex].commentImages.length) return;
      if (avgRating && commentCount > 0) {
        var imagesList = [];
        if (userComments.length) {
          userComments = reviewsFn.handleComments(userComments);
          userComments.forEach(item => {
            var arr = item.commentImages.map(urlItem => {
              return {
                url: urlItem,
                reviewsId: item.id
              }
            });
            if (arr.length) {
              imagesList = imagesList.concat(arr);
            } 
          });
        }
        if (imagesList.length > 0) {
          productReviewsImageList = imagesList;
          var reviewListImagesTml = LS.tmpl(reviewDetailSliderHtml, imagesList);
          containerDom.find('.reviews-detail_slider-box').html(reviewListImagesTml);

          var targetItem = userComments[currentReviewsImageIndex];
          var imageIdx = imagesList.findIndex(item => item.reviewsId === targetItem.id);
          if (imageIdx >= 0) {
            var reviewInfoTml = LS.tmpl(reviewsDetailInfoHtml, targetItem);
            containerDom.find('.reviews-detail_slider-index').text(Number(currentReviewsImageIndex) + 1);
            containerDom.find('.reviews-detail_info-wrapper').html(reviewInfoTml);
            $('.reviews-detail_score-view').html();
            LS.ui.genReviewsStar(targetItem.rating, '.reviews-detail_info', 'yellow', 'small');
          }
          reviewsDetailImgScrollLen = 0;
          selectedProductReviews = targetItem;
          $('.reviews-detail-container').show();
          LS.ui.popupNoScrollHandle();

          setTimeout(function() {
            var imageSlideToIndex = imagesList.findIndex(item => item.reviewsId === targetItem.id);
            var scrollLen = $('.reviews-detail_slider-box')[0].getBoundingClientRect().width || 0;
            reviewsDetailImgScrollLen = imageSlideToIndex >= 0 ? imageSlideToIndex * scrollLen : 0;
            containerDom.find('.reviews-detail_slider-index').text(Number(imageSlideToIndex) + 1);
            $('.reviews-detail_slider-images-wrapper').css('margin-left', `-${reviewsDetailImgScrollLen}px`);
          }, 500);
        }
      }
    },
    calcModuleData: function(domClassName) {
      var clsname = '.' + domClassName; // 此处类名没点
      var module = $(clsname);
      var itemList = module.find('.product-reviews_module-list-item');
      var moduleWidth = document.getElementsByClassName(domClassName)[0].getBoundingClientRect().width;
      var maxLabelWidth = 0;
      var maxPercentWidth = 0;
      for (var i = 0, len = itemList.length; i < len; i++) {
        var label = $(itemList[i]).find('.product-reviews_module-item-label');
        var percent = $(itemList[i]).find('.product-reviews_module-item-percent');
        if (label.width() > maxLabelWidth) {
          maxLabelWidth = label.width();
        }
        if (percent.width() > maxPercentWidth) {
          maxPercentWidth = percent.width();
        }
      }
      var progressWidth = moduleWidth - maxLabelWidth - maxPercentWidth - 50;
      module.find('.product-reviews_module-item-label').css({ width: maxLabelWidth });
      module.find('.product-reviews_module-item-progress-wrapper').css({ width: progressWidth });
      module.find('.product-reviews_module-item-percent').css({ width: maxPercentWidth });
      for (var i = 0, len = itemList.length; i < len; i++) {
        var progress = $(itemList[i]).find('.product-reviews_module-item-progress-wrapper');
        var val = progress.attr('data-value');
        var count = progress.attr('data-total-count');
        progress.find('.product-reviews_module-item-progress').css({ width: progressWidth * (val/count) });
      }
    },
    getSingleProductReviews: function(pageSize = -1) {
      return new Promise(function(resolve, reject) {
        var productId = $("#product-page").attr('data-product-id') || '';
        if (!productId) return reject();
        LS.ajax({
          url: LS.ui.routes.getProductCommentInfo,
          type: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: JSON.stringify({
            productId: productId + ''
          }),
          observeKeys: ['data.userComments'],
          success: function (res) {
            if (res.hasError || res.code !== '0') {
              $('.product-reviews-wrapper_pc').hide();
              // LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
              return;
            };
            var { avgRating, commentCount, userComments, fitOptions, priceOptions, qualityOptions } = res.data || {};
            productReviewsObj = res.data || {};
            var hideClsName = 'module-initial-hide';
            if (avgRating) {
              // 总评分
              $('.product-reviews_score-wrapper').find('.product-reviews_score-num-span1').text(avgRating);
              $('.product-reviews_score-wrapper').find('.product-reviews_score-num-span2').text(userComments.length);
              LS.ui.genReviewsStar(avgRating, '#product-reviews_pc', 'yellow', 'large', false);

              // 有评论才显示
              if (commentCount > 0) {
                LS.ui.genReviewsStar(avgRating, '#reviews-box_pc', 'yellow', 'small', false);
                $('#reviews-box_pc').find('.reviews-info .score').text(`${Number(avgRating).toFixed(1) + '/5.0' }`);
                $('#reviews-box_pc').find('.reviews-info .info').html(userComments.length);
                $('.product-top-wrapper .product-title-wrapper').addClass('has-reviews');
                $('.product-reviews-wrapper_top').removeClass(hideClsName);

                if (qualityOptions.length) {
                  var quanlityData = {
                    label: LS.$t('product.module_reviews.quality'),
                    totalCount: commentCount,
                    list: qualityOptions.map(item => {
                      return {
                        ...item,
                        width: 116 * (item.value / commentCount),
                        percent: Number.parseInt((item.value / commentCount) * 100)
                      }
                    })
                  }
                  var moduleTmpl = LS.tmpl(reviewsModule, quanlityData);
                  $('.product-reviews_module-wrapper').find('.product-reviews_module-item_quality').html(moduleTmpl);
                  setTimeout(function() {
                    reviewsFn.calcModuleData('product-reviews_module-item_quality');
                  }, 500);
                }

                if (priceOptions.length) {
                  var priceData = {
                    label: LS.$t('product.module_reviews.value'),
                    totalCount: commentCount,
                    list: priceOptions.map(item => {
                      return {
                        ...item,
                        width: 116 * (item.value / commentCount),
                        percent: Number.parseInt((item.value / commentCount) * 100)
                      }
                    })
                  }
                  var moduleTmpl = LS.tmpl(reviewsModule, priceData);
                  $('.product-reviews_module-wrapper').find('.product-reviews_module-item_price').html(moduleTmpl);
                  setTimeout(function() {
                    reviewsFn.calcModuleData('product-reviews_module-item_price');
                  }, 500);
                }

                if (isKindBelong.clothes && fitOptions.length) {
                  var fitData = {
                    label: LS.$t('product.module_reviews.fit'),
                    totalCount: commentCount,
                    list: fitOptions.map(item => {
                      return {
                        ...item,
                        width: 116 * (item.value / commentCount),
                        percent: Number.parseInt((item.value / commentCount) * 100)
                      }
                    })
                  }
                  var moduleTmpl = LS.tmpl(reviewsModule, fitData);
                  $('.product-reviews_module-wrapper').find('.product-reviews_module-item_fit').html(moduleTmpl).show();
                  setTimeout(function() {
                    reviewsFn.calcModuleData('product-reviews_module-item_fit');
                  }, 500);
                }

                $('.product-reviews_module-wrapper').removeClass(hideClsName);
              }
              // 买家秀
              if (userComments.length) {
                userComments = reviewsFn.handleComments(userComments);

                // 截取评论列表前pageSize个
                var reviewsArr = userComments.slice();
                if (pageSize > 0) {
                  reviewsArr.splice(pageSize);
                }
                 // 评论列表
                var reviewListTemplate = LS.tmpl(reviewsListHtml, reviewsArr);
                $('.product-reviews-list_pc').html(reviewListTemplate);

                var reviewslist = $('.product-reviews-list_pc').find('.reviews-item');
                for (var i = 0, len = reviewslist.length; i < len; i++) {
                  var target = $(reviewslist[i]);
                  var id = target.attr('data-id');
                  var score = target.attr('data-score');
                  // 区分dom，避免重复插入
                  target.addClass('product-reviews-item');
                  LS.ui.genReviewsStar(score, `.product-reviews-item.reviews-item-${id}`, 'yellow', 'small');
                }
                $('.product-reviews_view-more').removeClass(hideClsName);
              }
              $('.product-reviews-wrapper_pc').show();
            }
            resolve();
          },
          error: function (error) {
            $('.product-reviews-wrapper_pc').hide();
            //  LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
             reject();
          },
        });
      })
    },
    handleComments: function(arr) {
      if (!arr.length) return [];
      if (!isKindBelong.clothes) {
        for (var i = 0, len = arr.length; i < len; i++) {
          delete arr[i].fit;
        }
      }
      return arr.map(item => {
        var variantInfo = item.variantTitle ? item.variantTitle.split('/') : '';
        var color = variantInfo.length ? variantInfo[0].trim() : '';
        var size = variantInfo.length ? variantInfo[1].trim() : '';
        return {
          ...item,
          createTimeStr: LS.i18n.fmtTime(item.createTime),
          color,
          size
        }
      })
    },
    getSingleProductAllReviews: function(productId) {
      if (!productId) return;
      if (currentProductId === productId) {
        $('.reviews-popupbox').show();
        return;
      };
      currentProductId = productId;
      LS.ajax({
        url: LS.ui.routes.getProductCommentInfo,
        type: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          productId: productId + ''
        }),
        success: function (res) {
          if (res.hasError || res.code !== '0') {
            // LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
            return;
          };
          var { avgRating, commentCount, userComments } = res.data || {};
          if (avgRating && commentCount > 0) {
            if (userComments.length) {
              userComments = reviewsFn.handleComments(userComments);

              // 评论列表
              var reviewListTemplate = LS.tmpl(reviewsListHtml, userComments);
              $('.reviews-list_dialog').html(reviewListTemplate);

              var reviewslist = $('.reviews-list_dialog').find('.reviews-item');
              for (var i = 0, len = reviewslist.length; i < len; i++) {
                var target = $(reviewslist[i]);
                var id = target.attr('data-id');
                var score = target.attr('data-score');
                // 区分dom，避免重复插入
                target.addClass('drawer-reviews-item');
                LS.ui.genReviewsStar(score, `.drawer-reviews-item.reviews-item-${id}`, 'yellow', 'small');
              }
            }
            $('.reviews-popupbox').show();
          }
        },
        error: function (error) {
            // LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
        },
      });
    },
    getRecomComments: function() {
      LS.ajax({
        url: LS.ui.routes.getRecomComments,
        type: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        success: function (res) {
          if (res.hasError || res.code !== '0') {
            // LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
            return;
          };
          var list = res.data || [];
          if (list.length) {
            list = reviewsFn.handleComments(list);
            homeRecomLen = list.length;
            var template = LS.tmpl(reviewsBlockItemHtml, list);
            $('.looksky-reviews_list-wrapper').html(template);
            $('.looksky-reviews-block').show();
            var reviewslist = $('.looksky-reviews_list-wrapper').find('.index_reviews-item');
            for (var i = 0, len = reviewslist.length; i < len; i++) {
              var target = $(reviewslist[i]);
              var idx = target.attr('data-index');
              var score = target.attr('data-score');
              LS.ui.genReviewsStar(score, `.index_reviews-item-${idx}`, 'yellow', 'small');
            }
          }
        },
        error: function (error) {
            // LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
        },
      });
    }
  }

  function init() {
    if (LS.site.page == 'product') {
      reviewsFn.getSingleProductReviews(2);
    }
    if (LS.site.page === 'index') {
      reviewsFn.getRecomComments();
    }
    reviewsFn.bindEvent();
    setTimeout(function() {
      reviewsFn.insertDrawer();
      reviewsFn.insertDetailDrawer();
    }, 500)
  }
  init();
})();